import { getGroupValueById } from '../site/site-table/body-elements/body-row/getGroupValueById';
import type Table from '../site/site-table/custom-table/table/Table';

export function addSelectedGroup(table: Table, groupId: string, count: number): void {
  table.selectedGroupCounts.set(groupId, count);
}

export function removeSelectedGroup(table: Table, groupId: string): void {
  table.selectedGroupCounts.delete(groupId);
}

export function clearSelectedGroups(table: Table): void {
  table.selectedGroupCounts.clear();
}

export function isPointInSelectedGroup(table: Table, pointId: string): boolean {
  if (table.selectedGroupCounts.size === 0) {
    return false;
  }

  for (const groupId of table.selectedGroupCounts.keys()) {
    const group = getGroupValueById(groupId);

    if (group?.pointObjects?.some((point) => point._id === pointId)) {
      return true;
    }
  }

  return false;
}

export function refreshSelectedGroupSelections(table: Table): void {
  if (table.selectedGroupCounts.size === 0) {
    return;
  }

  for (const groupId of Array.from(table.selectedGroupCounts.keys())) {
    const group = getGroupValueById(groupId);

    if (!group) {
      table.selectedGroupCounts.delete(groupId);
      continue;
    }

    group.pointObjects?.forEach((point) => {
      if (!table.deselectedPoints.has(point._id)) {
        table.selectedPoints.add(point._id);
      }
    });
  }
}

export function recomputeSelectedPointsCount(table: Table): void {
  if (table.hasSelectedAllPoints) {
    return;
  }

  table.selectedPointsCount =
    table.selectedGroupCounts.size > 0
      ? computeGroupAwareSelectedCount(table)
      : table.selectedPoints.size;
}

function computeGroupAwareSelectedCount(table: Table): number {
  let virtualUnloadedCount = 0;

  table.selectedGroupCounts.forEach((count, groupId) => {
    const loadedInGroup = getGroupValueById(groupId)?.pointObjects?.length ?? 0;

    virtualUnloadedCount += Math.max(0, count - loadedInGroup);
  });

  return table.selectedPoints.size + virtualUnloadedCount;
}
